import React from 'react';

export const BrandLogo = ({ className = 'w-10 h-10', testId = 'brand-logo' }) => (
  <img src="/logo.png" alt="Legacy Forge Family logo" className={`${className} rounded-lg shrink-0`} data-testid={testId} />
);
